import React from 'react';
import { motion } from 'framer-motion';

const HeroSection: React.FC = () => {
  return (
    <div className="relative overflow-hidden pt-16 md:pt-0">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="z-10"
        >
          <motion.h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Votre fidélité au <motion.span 
              className="text-[#7B1FA2]"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >centre-ville</motion.span> récompensée
          </motion.h1>
          
          <motion.p 
            className="text-lg md:text-xl opacity-90 mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            Gagnez des points à chaque achat chez vos commerçants préférés et échangez-les contre des offres exclusives. Soutenez l'économie locale tout en étant récompensé.
          </motion.p>
          
          <div className="flex flex-wrap gap-4">
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.2)" }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.5 }}
              className="px-8 py-3 bg-[#7B1FA2] text-white rounded-full font-semibold shadow-lg"
            >
              Télécharger l'application
            </motion.button>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.5 }}
              className="px-8 py-3 bg-white/20 backdrop-blur-sm border border-white/30 text-white rounded-full font-semibold hover:bg-white/30 transition-colors"
            >
              En savoir plus
            </motion.button>
          </div>
          
          <motion.div 
            className="mt-8 flex items-center gap-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.8 }}
          >
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map(i => (
                <motion.div 
                  key={i}
                  className="w-10 h-10 rounded-full border-2 border-white overflow-hidden"
                  initial={{ x: -30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.9 + i * 0.1, duration: 0.5 }}
                >
                  <img 
                    src={`https://i.pravatar.cc/100?img=${i+10}`} 
                    className="w-full h-full object-cover" 
                    alt="Utilisateur" 
                  />
                </motion.div>
              ))}
            </div>
            <p className="text-sm opacity-90">Déjà +2500 utilisateurs satisfaits</p>
          </motion.div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="relative z-10 mt-12 md:mt-0"
        >
          <motion.div
            animate={{ 
              y: [0, -15, 0],
              rotateZ: [0, 2, 0]
            }}
            transition={{ 
              repeat: Infinity, 
              duration: 5,
              ease: "easeInOut" 
            }}
            className="relative"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-[#7B1FA2]/60 to-[#40E0D0]/60 blur-xl rounded-3xl transform translate-y-4 scale-95 -rotate-3"></div>
            <img 
              src="https://raw.githubusercontent.com/cruip/cruip-tutorials/master/spotlight-cursor-effect/src/app-mockup.png" 
              alt="Application mobile" 
              className="relative z-10 w-full max-w-lg mx-auto rounded-2xl shadow-2xl"
            />
          </motion.div>
          
          <motion.div 
            className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#40E0D0] rounded-2xl z-0 opacity-80"
            animate={{ 
              rotate: [0, 10, -10, 0],
              scale: [1, 1.05, 0.95, 1]
            }}
            transition={{ repeat: Infinity, duration: 10, ease: "easeInOut" }}
          />
          
          <motion.div 
            className="absolute -top-8 -left-8 w-32 h-32 bg-[#7B1FA2] rounded-full z-0 opacity-50"
            animate={{ 
              rotate: [0, -10, 10, 0],
              scale: [1, 0.95, 1.05, 1]
            }}
            transition={{ repeat: Infinity, duration: 8, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
      
      <motion.div 
        className="absolute -bottom-32 -left-32 w-64 h-64 bg-[#40E0D0] rounded-full opacity-20 blur-3xl"
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ repeat: Infinity, duration: 15, ease: "easeInOut" }}
      />
      
      <motion.div 
        className="absolute -top-32 -right-32 w-64 h-64 bg-[#7B1FA2] rounded-full opacity-20 blur-3xl"
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ repeat: Infinity, duration: 20, ease: "easeInOut" }}
      />
    </div>
  );
};

export default HeroSection;
